module.exports = __webpack_public_path__ + "static/media/zocalo11.8d139f6e.jpg";